// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.connecting-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}
.connecting-container .connecting-card {
  position: relative;
  border-radius: 1.25rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 0 8px 16px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.05);
  padding: 2.5rem;
  width: 22rem;
  text-align: center;
  backdrop-filter: blur(10px);
  overflow: hidden;
}
.connecting-container .connecting-card::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at center, rgba(114, 137, 218, 0.05) 0%, rgba(114, 137, 218, 0) 70%);
  z-index: 0;
}
.connecting-container .connecting-card.connected {
  animation: fadeIn 0.5s ease-out forwards;
}
.connecting-container .connecting-card.connected .icon-circle {
  background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
  box-shadow: 0 0 0 10px rgba(16, 185, 129, 0.1), 0 0 30px rgba(16, 185, 129, 0.3);
}
.connecting-container .connecting-card.connected .icon-circle .icon {
  color: #ffffff;
}
.connecting-container .connecting-card.connected .status-text {
  background: black;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.connecting-container .icon-container {
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
}
.connecting-container .icon-container .icon-circle {
  width: 5rem;
  height: 5rem;
  margin: 0 auto 1.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #7289da 0%, #5865f2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 10px rgba(88, 101, 242, 0.1);
  position: relative;
}
.connecting-container .icon-container .icon-circle::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  animation: pulse 2s infinite;
}
.connecting-container .icon-container .icon-circle .icon {
  width: 2.5rem;
  height: 2.5rem;
  color: #ffffff;
}
.connecting-container .status-text {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
  letter-spacing: 0.01em;
}
.connecting-container .dots-container {
  display: inline-block;
  width: 2rem;
  text-align: left;
  opacity: 0.8;
}
.connecting-container .progress-bar-container {
  position: relative;
  height: 0.5rem;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 9999px;
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.connecting-container .progress-bar-container .progress-bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #7289da 0%, #5865f2 100%);
  transition: width 700ms cubic-bezier(0.34, 1.56, 0.64, 1);
  border-radius: 9999px;
}
.connecting-container .progress-bar-container .progress-bar-fill::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 100%);
  animation: shimmer 2s infinite;
}
.connecting-container::after {
  content: attr(data-progress) "%";
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/components/ConnectingAnimation/ConnectingAnimation.scss"],"names":[],"mappings":"AAEA;EACE;IAAK,mBAAA;IAAqB,UAAA;EAC1B;EAAA;IAAM,qBAAA;IAAuB,UAAA;EAI7B;EAHA;IAAO,mBAAA;IAAqB,UAAA;EAO5B;AACF;AALA;EACE;IAAK,4BAAA;EAQL;EAPA;IAAO,2BAAA;EAUP;AACF;AARA;EACE;IAAO,UAAA;IAAY,2BAAA;EAYnB;EAXA;IAAK,UAAA;IAAY,wBAAA;EAejB;AACF;AAbA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EAEA,mEAAA;AAcF;AAZE;EACE,kBAAA;EAEA,sBAAA;EACA,8GACQ;EAGR,eAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AAUJ;AAPI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uGAAA;EAKA,UAAA;AAKN;AAFI;EACE,wCAAA;AAIN;AAFM;EACE,6DAAA;EACA,gFACQ;AAGhB;AAAQ;EACE,cAAA;AAEV;AAEM;EACE,iBAAA;EACA,6BAAA;EACA,oCAAA;AAAR;AAKE;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;AAHJ;AAKI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,kBAAA;AAHN;AAKM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,4BAAA;AAHR;AAMM;EACE,aAAA;EACA,cAAA;EACA,cAAA;AAJR;AASE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AARJ;AAWE;EACE,kBAAA;EACA,cAAA;EACA,2CAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AATJ;AAWI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,4DAAA;EACA,yDAAA;EACA,qBAAA;AATN;AAWM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,wHAAA;EAMA,8BAAA;AAdR;AAoBE;EACE,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,+BAAA;AAlBJ","sourcesContent":["// ConnectingAnimation.scss\n\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 1; }\n  70% { transform: scale(1.5); opacity: 0; }\n  100% { transform: scale(1); opacity: 0; }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.connecting-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  //background: linear-gradient(135deg, #1a1f25 0%, #121417 100%);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n\n  .connecting-card {\n    position: relative;\n    //background-color: rgba(30, 35, 44, 0.95);\n    border-radius: 1.25rem;\n    box-shadow:\n            0 20px 40px rgba(0, 0, 0, 0.3),\n            0 8px 16px rgba(0, 0, 0, 0.2),\n            0 0 0 1px rgba(255, 255, 255, 0.05);\n    padding: 2.5rem;\n    width: 22rem;\n    text-align: center;\n    backdrop-filter: blur(10px);\n    overflow: hidden;\n\n    // Ambient background effects\n    &::before {\n      content: '';\n      position: absolute;\n      top: -50%;\n      left: -50%;\n      width: 200%;\n      height: 200%;\n      background: radial-gradient(\n                      circle at center,\n                      rgba(114, 137, 218, 0.05) 0%,\n                      rgba(114, 137, 218, 0) 70%\n      );\n      z-index: 0;\n    }\n\n    &.connected {\n      animation: fadeIn 0.5s ease-out forwards;\n\n      .icon-circle {\n        background: linear-gradient(135deg, #34d399 0%, #10b981 100%);\n        box-shadow:\n                0 0 0 10px rgba(16, 185, 129, 0.1),\n                0 0 30px rgba(16, 185, 129, 0.3);\n\n        .icon {\n          color: #ffffff;\n        }\n      }\n\n      .status-text {\n        background: black;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n      }\n    }\n  }\n\n  .icon-container {\n    margin-bottom: 2rem;\n    position: relative;\n    z-index: 1;\n\n    .icon-circle {\n      width: 5rem;\n      height: 5rem;\n      margin: 0 auto 1.5rem;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #7289da 0%, #5865f2 100%);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 0 0 10px rgba(88, 101, 242, 0.1);\n      position: relative;\n\n      &::after {\n        content: '';\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        border-radius: 50%;\n        border: 2px solid rgba(255, 255, 255, 0.4);\n        animation: pulse 2s infinite;\n      }\n\n      .icon {\n        width: 2.5rem;\n        height: 2.5rem;\n        color: #ffffff;\n      }\n    }\n  }\n\n  .status-text {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n    position: relative;\n    z-index: 1;\n    letter-spacing: 0.01em;\n  }\n\n  .dots-container {\n    display: inline-block;\n    width: 2rem;\n    text-align: left;\n    opacity: 0.8;\n  }\n\n  .progress-bar-container {\n    position: relative;\n    height: 0.5rem;\n    background-color: rgba(255, 255, 255, 0.08);\n    border-radius: 9999px;\n    overflow: hidden;\n    margin-bottom: 0.75rem;\n\n    .progress-bar-fill {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      background: linear-gradient(90deg, #7289da 0%, #5865f2 100%);\n      transition: width 700ms cubic-bezier(0.34, 1.56, 0.64, 1);\n      border-radius: 9999px;\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 30%;\n        height: 100%;\n        background: linear-gradient(\n                        90deg,\n                        rgba(255, 255, 255, 0) 0%,\n                        rgba(255, 255, 255, 0.3) 50%,\n                        rgba(255, 255, 255, 0) 100%\n        );\n        animation: shimmer 2s infinite;\n      }\n    }\n  }\n\n  // Display progress percentage\n  &::after {\n    content: attr(data-progress) '%';\n    position: absolute;\n    bottom: 1.5rem;\n    right: 1.5rem;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.5);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
